const modalOpenClass = 'js-modal-open';

window.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(modalOpenClass);
  if (!elements) {
    return;
  }
  Array.from(elements).forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault();
      const modalId = element.dataset.modalId;
      MicroModal.show(modalId,{
          disableScroll: true,
          awaitOpenAnimation: true,
          awaitCloseAnimation: true,
          disableFocus: true,
      });
    });
  });
});
